import angular from 'angular';
import { formatAwt } from '../utils';

const module = angular.module('whyline.filters.estimatedWaitTime', []);

const filter = () => (averageWaitingTime, waitingPeople) => formatAwt(averageWaitingTime * waitingPeople);

module.exports = module.filter('estimatedWaitTime', filter);
